/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Employee } from './Employee';
import {
    EmployeeFromJSON,
    EmployeeFromJSONTyped,
    EmployeeToJSON,
    EmployeeToJSONTyped,
} from './Employee';

/**
 * 
 * @export
 * @interface ShowCurrentEmployeeResponse
 */
export interface ShowCurrentEmployeeResponse {
    /**
     * 
     * @type {Employee}
     * @memberof ShowCurrentEmployeeResponse
     */
    data: Employee;
}

/**
 * Check if a given object implements the ShowCurrentEmployeeResponse interface.
 */
export function instanceOfShowCurrentEmployeeResponse(value: object): value is ShowCurrentEmployeeResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowCurrentEmployeeResponseFromJSON(json: any): ShowCurrentEmployeeResponse {
    return ShowCurrentEmployeeResponseFromJSONTyped(json, false);
}

export function ShowCurrentEmployeeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowCurrentEmployeeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmployeeFromJSON(json['data']),
    };
}

  export function ShowCurrentEmployeeResponseToJSON(json: any): ShowCurrentEmployeeResponse {
      return ShowCurrentEmployeeResponseToJSONTyped(json, false);
  }

  export function ShowCurrentEmployeeResponseToJSONTyped(value?: ShowCurrentEmployeeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmployeeToJSON(value['data']),
    };
}

